import { G_listResolutions } from "../globals/list-resolutions";
import setWindowData from "../set-window-data";
import WINDOW from "../window";

/**
 * Check if the resolution string is in the current screen size
 * @param {String} resolution
 * @returns {Boolean}
 */
const isInResolution = (resolution) => {
  const windowWidth = /** @type {Number | Boolean} */ (WINDOW.get("width"));

  if (!windowWidth) {
    setWindowData();
  }

  const width = G_listResolutions.get(resolution) || true;

  return width < windowWidth;
};

export default isInResolution;
